import React from "react";
import { NumericFormat } from "react-number-format";

const CurrencyInput = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      prefix="$"
      getInputRef={ref}
      thousandSeparator
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.floatValue,
          },
        });
      }}
    />
  );
});

export default CurrencyInput;
